import { render } from "./TheTruong_GiaoVien.vue?vue&type=template&id=6e3bd3ce"
import script from "./TheTruong_GiaoVien.vue?vue&type=script&lang=js"
export * from "./TheTruong_GiaoVien.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__